import React, { useCallback } from 'react';
import { useStore, getStraightPath, EdgeProps } from 'reactflow';

import { getEdgeParams } from '../../../utils/nodeUtils';

function EdgeLine({ id, source, target, style }: EdgeProps) {
  const sourceNode = useStore(useCallback(store => store.nodeInternals.get(source), [source]));
  const targetNode = useStore(useCallback(store => store.nodeInternals.get(target), [target]));

  if (!sourceNode || !targetNode) {
    return null;
  }

  const { sx, sy, tx, ty } = getEdgeParams(sourceNode, targetNode);

  const [edgePath] = getStraightPath({
    sourceX: sx,
    sourceY: sy,
    targetX: tx,
    targetY: ty,
  });

  return <path id={id} className="react-flow__edge-path edgeLine" d={edgePath} strokeWidth={5} style={style} />;
}

export default EdgeLine;
